import React from 'react'
import { PDFViewer, Page,View, Text, Document, StyleSheet, Font, } from "@react-pdf/renderer";
import { Breadcrumb, BreadcrumbItem } from 'reactstrap'
import { format } from 'date-fns'
import { useParams, useHistory } from 'react-router'
import { FindOne, LeaveTypeAPI } from '../../components/functions/LeaveRequestPage';
import { useTranslation } from 'react-i18next'
import { Link } from "react-router-dom";


import Sarabun from '../../font/Sarabun/Sarabun-Regular.ttf'
// import SarabunBold from '../../font/Sarabun/Sarabun-Bold.ttf'
// import SarabunItalic from '../../font/Sarabun/Sarabun-Italic.ttf'

// Create styles
Font.register({
    family: 'Sarabun',
    // src: '../../../public/assets/fonts/Sarabun-Regular.ttf'
    src: Sarabun
    // fonts: [
    //     {
    //         src: SarabunRegular,
    //     },
    //     {
    //         src: SarabunItalic,
    //         fontStyle: 'italic',
    //     },
    //     {
    //         src: SarabunBold,
    //         fontWeight: 'bold',
    //     },
    // ],
});

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Sarabun',
        fontSize: 12,
        margin: 12,
        paddingTop: 35,
        paddingLeft: 35,
        paddingRight: 35,
        paddingBottom: 65,
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        marginBottom: 10,
    },
    header: {
        marginBottom: 20,
        borderBottom: '1px solid #ccc',
        paddingBottom: 5,
    },
    title: {
        fontSize: 22,
        textAlign: 'center',
        fontWeight: 'bold',
        marginBottom: 10,
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginBottom: 10,
    },
    content: {
        marginBottom: 10,
    },
});

// const styles = StyleSheet.create({
//     page: {
//         fontFamily: 'Kanit',
//         fontSize: 12,
//         paddingTop: 35,
//         paddingLeft: 35,
//         paddingRight: 35,
//         paddingBottom: 65,
//       },
//     body: {
//         paddingTop: 35,
//         paddingBottom: 65,
//         paddingHorizontal: 35,
//     },
//     title: {
//         fontSize: 24,
//         textAlign: 'center',
//         fontFamily: 'Kanit',
//         marginBottom: 20
//     },
//     author: {
//         fontSize: 12,
//         textAlign: 'center',
//         marginBottom: 40
//     },
//     subtitle: {
//         fontSize: 16,
//         margin: 12,
//         fontFamily: 'Times-Roman'
//     },
//     text: {
//         margin: 12,
//         fontSize: 14,
//         textAlign: 'justify',
//         fontFamily: 'Times-Roman'
//     },
// });


const LeavePDF = () => {

    const { t } = useTranslation()
    const { id } = useParams();
    const history = useHistory();
    const [values, setValues] = React.useState({
        EmpNo: '-',
        LeaveType: '-',
        Reason: '-',
        UserName: '-',
        Position: '-',
        Department: '-',
        LeaveDay: '-',
        LeaveTime: '-',
        ToDate: '-',
        EndDate: '-',
    })

    const getData = React.useCallback(async () => {
        try {
            const result = await FindOne(id)

            const TypeList = await LeaveTypeAPI()

            const v_type = TypeList.data.leaveType.find(itme => {
                return itme.TYPECD = result.data.leave.TYPECD
            })
            setValues({
                ...values,
                EmpNo: result.data.leave.EMP_NO,
                LeaveType: v_type.TYPENM,
                Reason: result.data.leave.REASON,
                UserName: result.data.leave.employees.FULL_NAME,
                Position: result.data.leave.employees.POSITION,
                Department: result.data.leave.employees.DEPARTMENT,
                LeaveDay: result.data.leave.DAYS_QTY,
                LeaveTime: result.data.leave.MIN_QTY,
                ToDate: (format(new Date(result.data.leave.BEGIN_DT), 'dd/MM/yyyy')),
                EndDate: (format(new Date(result.data.leave.END_DT), 'dd/MM/yyyy')),


            })
            // console.log(values)

        } catch (error) {
            history.replace("/dashboard")
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, setValues])


    React.useEffect(() => {
        // console.log('useEffect edit page')
        getData();

        setTimeout(() => {
        }, 1000);

    }, [getData]);
    return (
        <>
            <div className="mt-5 container-xl">
                <Breadcrumb listTag="div">
                    <BreadcrumbItem >
                        <Link to="/dashboard"> 	{t("t_dashboard")} </Link>
                    </BreadcrumbItem>
                    <BreadcrumbItem
                        active
                        tag="span"
                    >
                        {id}
                    </BreadcrumbItem>
                </Breadcrumb>

                <PDFViewer className='mt-3 container-fluid' height={800}>
                    {/* <Document>

                        <Page style={styles.body}>

                            <Text style={styles.subtitle}>โดยที่การยอมรับศักดิ์ศรีแต่กำเนิด และสิทธิที่เท่าเทียมกันและที่ไม่อาจเพิกถอนได้ของสมาชิกทั้งมวลแห่งครอบครัวมนุษยชาติ เป็นพื้นฐานแห่งอิสรภาพ ความยุติธรรม และสันติภาพในโลก การไม่นำพาและการหมิ่นในคุณค่าของสิทธิมนุษยชน ยังผลให้มีการกระทำอันป่าเถื่อน ซึ่งเป็นการขัดอย่างร้ายแรงต่อมโนธรรมของมนุษยชาติ และการมาถึงของโลกที่ได้มีการประกาศให้ความมีอิสรภาพในการพูดและความเชื่อ และอิสรภาพจากความหวาดกลัวและความต้องการของมนุษย์ เป็นความปรารถนาสูงสุดของประชาชนทั่วไป</Text>
                        </Page>
                    </Document> */}

                    <Document>
                        <Page size="A4" style={styles.page}>
                            <View style={styles.section}>
                                <View style={styles.header}>
                                    <Text style={styles.title}>ใบลา</Text>
                                    {/* <Text style={styles.subtitle}>แบบใบลาป่วย ลากิจส่วนตัว  ลาคลอดบุตร</Text> */}
                                </View>
                                <View style={styles.content}>
                                    <Text>ชื่อ - สกุล : {values.UserName}</Text>
                                    <Text>รหัสพนักงาน : {values.EmpNo}</Text>
                                    <Text>ตำแหน่ง: {values.Position}</Text>
                                    <Text>แผนก: {values.Department}</Text>
                                    <Text>วันลา: {values.EmpNo}</Text>
                                    <Text>เหตุผลการลา: {values.Reason}</Text>
                                </View>
                            </View>
                        </Page>
                    </Document>
                </PDFViewer>
            </div>
        </>
    )

}
export default LeavePDF
